var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["image-view__holder", { "image-view__holder--empty": !_vm.src }],
    },
    [
      _c("v-img", { staticClass: "image-view__img", attrs: { src: _vm.src } }),
      _vm.src
        ? _c(
            "div",
            { staticClass: "image-view__preview" },
            [_c("v-img", { attrs: { src: _vm.src } })],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }